// src/theme/darkTheme.js
import { createTheme } from '@mui/material/styles';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: '#121212',
      paper:   '#1e1e1e',
    },
    // Optional: brand color
    primary: { main: '#3f51b5' },
  },
  components: {
    // Optional niceties:
    MuiPaper: { styleOverrides: { root: { backgroundImage: 'none' } } },
    MuiButton: { styleOverrides: { root: { textTransform: 'none' } } },
  },
});

export default darkTheme;
